module.exports = __webpack_public_path__ + "static/media/bankofireland.12bc2ad9.png";